module.exports = __webpack_public_path__ + "img/STERiJECT_02_5.3397017d.png";